import React, { useEffect, useState } from 'react';
import { getLogs } from '../utils/api';
import { PageTitle, Card, Table, Loading, Empty, Grid, StatCard } from '../components/UI';

const actionColor = { INCREASE: '#55efc4', DECREASE: '#ffd200', PAUSE: '#ff6584', KEEP: '#6b6b80' };
const actionBg    = { INCREASE: 'rgba(85,239,196,0.1)', DECREASE: 'rgba(255,210,0,0.1)', PAUSE: 'rgba(255,101,132,0.1)', KEEP: 'rgba(107,107,128,0.1)' };

export default function Logs() {
  const [data, setData] = useState({ stats: {}, logs: [] });
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    getLogs({ limit: 100 })
      .then(r => setData(r.data?.data || {}))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const s = data.stats || {};
  const logs = (data.logs || []).filter(l =>
    !filter || l.action === filter || l.campaignName?.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div>
      <PageTitle title="🤖 AI Decision Logs" sub="AI কখন কি সিদ্ধান্ত নিলো — সম্পূর্ণ history" />

      <Grid cols={4}>
        <StatCard label="Total Decisions" value={s.total || 0} color="#a29bfe" />
        <StatCard label="Increased" value={s.increase || 0} color="#55efc4" />
        <StatCard label="Decreased" value={s.decrease || 0} color="#ffd200" />
        <StatCard label="Paused" value={s.pause || 0} color="#ff6584" />
      </Grid>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {['', 'INCREASE', 'DECREASE', 'PAUSE', 'KEEP'].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              background: filter === f ? (actionColor[f] || '#6c63ff') : '#1e1e2e',
              color: filter === f ? '#0f0f17' : '#6b6b80' }}>
            {f || 'All'}
          </button>
        ))}
      </div>

      <Card>
        {loading ? <Loading /> : logs.length === 0 ? <Empty msg="কোনো AI decision log নেই" /> : (
          <Table
            headers={['Action', 'Campaign', 'Old Budget', 'New Budget', 'ROAS', 'Reason', 'Time']}
            rows={logs.map((log, i) => (
              <tr key={i}>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <span style={{ padding: '4px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700,
                    color: actionColor[log.action], background: actionBg[log.action] }}>
                    {log.action}
                  </span>
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{log.campaignName}</div>
                  <div style={{ fontSize: 11, color: '#6b6b80' }}>{log.campaignId}</div>
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13, color: '#6b6b80' }}>
                  {log.currentBudget ? `৳${log.currentBudget}` : '—'}
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13, fontWeight: 600 }}>
                  {log.newBudget ? `৳${log.newBudget}` : '—'}
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13,
                  color: log.roas >= 3 ? '#55efc4' : log.roas >= 1.5 ? '#ffd200' : '#ff6584' }}>
                  {parseFloat(log.roas || 0).toFixed(2)}
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 12, color: '#6b6b80', maxWidth: 200 }}>
                  {log.reason}
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 11, color: '#6b6b80', whiteSpace: 'nowrap' }}>
                  {new Date(log.createdAt).toLocaleString('bn-BD')}
                </td>
              </tr>
            ))}
          />
        )}
      </Card>
    </div>
  );
}
